import React, { useState } from 'react';

const Contact = () => {
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  course: "",
  message: "",
});

const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value,
  });
};

const handleSubmit = async (e) => {
  e.preventDefault();

  const scriptURL = "https://script.google.com/macros/s/AKfycbxS9gSs2pjOfjjA8DYTdT8mPbp9nba1AyiW1tkckdX8Bfun4dlvf5YpzqK-1tekBElrdA/exec"; 

  // Mapping React form fields to Google Script expected fields
  const dataToSend = {
    fullname: formData.name,
    email: formData.email,
    phonenumber: formData.phone,
    interestedcourse: formData.course,
    message: formData.message,
  };

  try {
    const res = await fetch(scriptURL, {
      method: "POST",
      mode: "no-cors", // required for Google Script
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataToSend),
    });

    alert("Thank you! Your form has been submitted.");
    console.log("Form submitted:", dataToSend);

    // Clear form
    setFormData({
      name: "",
      email: "",
      phone: "",
      course: "",
      message: "",
    });

  } catch (error) {
    console.error("Error!", error);
    alert("Something went wrong. Please try again.");
  }
};


  return (
    <div className="py-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get In Touch
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Have questions? We're here to help. Contact us for any inquiries about our courses or services.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  placeholder="Enter your full name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  placeholder="Enter your email address"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  placeholder="Enter your phone number"
                />
              </div>

              <div>
                <label htmlFor="course" className="block text-sm font-medium text-gray-700 mb-2">
                  Interested Course
                </label>
                <select
                  id="course"
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                >
                  <option value="">Select a course</option>
                  <option value="neet">NEET</option>
                  <option value="jee">JEE</option>
                  <option value="mht-cet">MHT-CET</option>
                  <option value="foundation">Foundation</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  placeholder="Tell us about your requirements..."
                />
              </div>

              <button
                type="submit"
                className="w-full bg-primary text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Contact Information</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <span className="text-primary mr-3 mt-1">📍</span>
                  <div>
                    <h4 className="font-semibold text-gray-900">Address</h4>
                    <p className="text-gray-600"> Yeole Classes, near Sundarrao Solanke Mahavidyalaya, Gadi Rd, Manglanath Colony, Majalgaon, Maharashtra 431131</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-primary mr-3 mt-1">📞</span>
                  <div>
                    <h4 className="font-semibold text-gray-900">Phone</h4>
                    <p className="text-gray-600">+91-94047 95121</p>
                    <p className="text-gray-600">+91-88301 90142</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-primary mr-3 mt-1">✉️</span>
                  <div>
                    <h4 className="font-semibold text-gray-900">Email</h4>
                    <p className="text-gray-600">vijayeole8@gmail.com</p>
                    <p className="text-gray-600">yeoleclasses@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-primary mr-3 mt-1">🕒</span>
                  <div>
                    <h4 className="font-semibold text-gray-900">Office Hours</h4>
                    <p className="text-gray-600">Monday - Saturday: 7:00 AM - 7:00 PM</p>
                    <p className="text-gray-600">Sunday: 10:00 AM - 2:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Quick Links</h3>
              <div className="space-y-2">
                <a href="/courses" className="block text-gray-600 hover:text-primary transition-colors">
                  Browse Courses
                </a>
                <a href="/results" className="block text-gray-600 hover:text-primary transition-colors">
                  View Results
                </a>
                <a href="/about" className="block text-gray-600 hover:text-primary transition-colors">
                  About Us
                </a>
                <a href="#" className="block text-gray-600 hover:text-primary transition-colors">
                  Download Brochure
                </a>
              </div>
            </div>

            <div className="bg-primary text-white p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-4">Need Immediate Help?</h3>
              <p className="mb-4">Our support team is available 24/7 to assist you with any queries.</p>
              <a
                href="https://wa.me/919404795121"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bg-white text-primary px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors font-semibold">
                  Chat with Us
                </button>
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;